import(/* webpackMode: "eager" */ "/home/briar/git/DLOM-2-serverless/frontend/app/documentation/page.tsx");
